
document.addEventListener('DOMContentLoaded', function() {

    if(window.location.pathname === '/') {

        const hrefSelector = [
            document.querySelectorAll('.gallery--container .gallery--item-content-link'),
            document.querySelectorAll('.gallery--container .text-button')
        ];

        for(const selector of hrefSelector) {
            console.log(selector)
            createStoreSelectorCookie(selector);
        }

    } else {
        // console.log(window.location.hostname)
        const hrefs = document.querySelectorAll('a[href="/"]');
        const collectionHandle = document.cookie.split('; ').find(row => row.startsWith('store_selector_collection=')).split('=')[1];
        for(const href of hrefs) {
            href.href = collectionHandle;
        }
    }
});

function createStoreSelectorCookie(collectionSelector) {
    
    for(const collection of collectionSelector) {
        collection.addEventListener('click', function(event) {
            event.preventDefault();
           
            console.log(collection)
            const collectionHandle = collection.href;
            const cookieName = 'store_selector_collection';
            const cookieValue = collectionHandle;
            const expirationDays = 30;

            const expirationDate = new Date();
            expirationDate.setTime(expirationDate.getTime() + (expirationDays * 24 * 60 * 60 * 1000));
            const expires = "expires=" + expirationDate.toUTCString();

            document.cookie = cookieName + "=" + cookieValue + ";" + expires + ";path=/";
            console.log('Cookie created: ' + cookieName + "=" + cookieValue + "; " + expires + ";path=/");
            window.location.href = collection.href;
        });
    }
}

function redirectToPage() {
    if(window.location.pathname === '/' || window.location.pathname === '/en' || window.location.pathname === '/en/' ) {
        if(document.cookie.split('; ').find(row => row.startsWith('store_selector_collection='))) {
            const collectionHandle = document.cookie.split('; ').find(row => row.startsWith('store_selector_collection=')).split('=')[1];
            window.location.href = collectionHandle;
        } else {
            const overlayRedirect = document.querySelector('#overlayRedirect');
            if(overlayRedirect) {
                overlayRedirect.style.display = 'none';
            }
        }
    }
}

redirectToPage();